import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '@/_metronic/helpers'
import {
  Pricing,
  OffersQueryResponse,
  OfferFilters,
  Offer
} from './_models'

const BASE_URL = '/p2c/payment/pricing'

const getPricing = (query?: string): Promise<Array<Pricing>> => {
  return axios
    .get(`${BASE_URL}`)
    .then((response: AxiosResponse<Response<Array<Pricing>>>) => response.data)
    .then((response: Response<Array<Pricing>>) => response.data || [])
}

const getOffers = (query?: string): Promise<OffersQueryResponse> => {
  return axios
    .get(`${BASE_URL}/offers?${query}`)
    .then((d: AxiosResponse<OffersQueryResponse>) => {
      return d.data
    })
}

const getOfferFilters = (): Promise<OfferFilters | undefined> => {
  return axios
    .get(`${BASE_URL}/offers/filters`)
    .then((response: AxiosResponse<Response<OfferFilters>>) => response.data)
    .then((response: Response<OfferFilters>) => response.data)
}

const updatePricing = (pricing: Pricing): Promise<void> => {
  return axios
    .put(`${BASE_URL}/${pricing._id}`, {
      label: pricing.label,
      enabled: pricing.enabled,
    })
    .then((d: AxiosResponse<any>) => {
      return d.data
    })
}

const updateOffer = (pricingId: ID, offer: Offer): Promise<void> => {
  return axios
    .put(`${BASE_URL}/${pricingId}/offer`, {
      ...offer
    })
    .then((d: AxiosResponse<any>) => {
      return d.data
    })
}

export {
  getPricing,
  updatePricing,
  getOffers,
  getOfferFilters,
  updateOffer
}
